import React from 'react'
import Helmet from 'react-helmet'

import { LINKEDIN_ID } from '~/config'

const Linkedin = () => {
  return (
    <Helmet>
      <script async>
        {`
        _linkedin_partner_id = "${LINKEDIN_ID}";
        window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
        window._linkedin_data_partner_ids.push(_linkedin_partner_id);
        (function(){var s = document.getElementsByTagName("script")[0];
        var b = document.createElement("script");
        b.type = "text/javascript";b.async = true;
        b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
        s.parentNode.insertBefore(b, s);})();
        `}
      </script>
    </Helmet>
  )
}

export default Linkedin
